<template>
  <div>
      <!-- <van-notice-bar color="rgb(57, 118, 198)" background="#f5f7f9" left-icon="weapp-nav" :scrollable="false">
      共 {{total}} 条
    </van-notice-bar> -->
    <!-- <div style="font-size: 12px;height:25px;line-height:25px;margin-left:10px;">
      共{{total}}条
    </div> -->
    <van-cell v-for="(item, index) in list" :key="index" @click="toDetails(item)" >
      <div style="display: flex; flex: 10; align-items: center; height:100%; width:100%">
        <div style="flex: 2;">
          <div style="width:50px; height: 50px;" v-for="(item, index) in imageArr" :key="index">
            <van-image fit="cover" round  width="50px"  height="50px"  :src="item.image" />
          </div>
        </div>
        <div style="flex: 7;">
          <div class="custName-wrap" style="padding: 0;">
            <div class="custName">
              {{ item.custName }}
            </div>
          </div>
          <div>
            <div>
              <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custLevel">{{ formatHandel("custLevel", item.custLevel) }}</van-tag>   <!---客户等级-->
              <!---客户来源-->
              <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.industry" >{{ item.industry }}</van-tag><!--所属行业-->
              <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.unitNature">{{ formatHandel("unitNature", item.unitNature) }}</van-tag >  <!--单位性质-->
              <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custStatus" >{{ formatHandel("custStatus", item.custStatus) }}</van-tag> -->
            </div>
            <span style="color: #ccc; font-size: 12px">跟进：{{item.userName}} 创建时间：{{ item.createTime | timeFormat }}</span>
          </div>
        </div>
        <van-icon style="flex:0.5;" color="#c1c1c1" v-if="!isAdd" name="arrow" size="16" class="arrow-color" />
        <!-- <van-button v-if="isAdd" round type="info" size="mini">申请共享</van-button> -->
        <div v-if="isAdd">
          <van-button
            round
            type="info"
            v-if="
              item.custStatus != '0' &&
              $store.state.user.user.userId != item.userId"
            @click="handleShare(item)"
            v-hasPermi="['scrm:apply:add']"
            size="mini"
            >申请共享</van-button >
          <van-button
            round
            type="info"
            v-if="item.custStatus == '0'"
            @click="handleApply(item)"
            v-hasPermi="['scrm:apply:add']"
            size="mini"
            >&nbsp;&nbsp;&nbsp;申&nbsp;领&nbsp;&nbsp;&nbsp;</van-button>
          <van-button
            round
            type="info"
            size="mini"
            v-if="$store.state.user.user.userId == item.userId"
            @click="handleList(item)"
            v-hasPermi="['scrm:apply:add']"
            >&nbsp;&nbsp;&nbsp;查&nbsp;看&nbsp;&nbsp;&nbsp;</van-button >
        </div>
      </div>
    </van-cell>
    <van-dialog v-model="dialogShow" title="申请共享" width="95%" class="editClue" :beforeClose="beforeClose" show-cancel-button>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="form.contactDept" label="客户部门" placeholder="请输入客户部门" :rules="[{ required: true }]" required />
          <van-field v-model="form.contactDeptPerson" label="联系人" placeholder="请输入部门联系人" :rules="[{ required: true }]" required />
          <van-field v-model="form.contactDeptPhone" label="手机号码" placeholder="请输入联系人手机号码" :rules="[{ required: true }]" required />
          <van-field readonly clickable v-model="form.businessTypeName" @click="showPicker" label="业务类型" placeholder="请选择业务类型" :rules="[{ required: true }]" required />
        </van-cell-group>
      </van-form>
    </van-dialog>
    <van-popup v-model="showServiceTypeTree" position="bottom">
      <van-cascader title="请选择业务类型" :options="serviceTypeTreeList" :field-names="fieldNames" @close="showServiceTypeTree = false" @finish="onFinishServiceTypeTree" />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
// import { getUser } from '@/api/system/user'
import { batchApplyShare, addApply } from '@/api/scrm/mycust'
import { businessTypeList } from '@/api/admi/dept'
import { Cell, Tag, Button, Icon, Toast, Dialog, Cascader } from 'vant'
// import { getDicts } from '@/api/system/dict/data'
export default {
  name: 'ListItem',
  components: {
    vanCascader: Cascader,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      dialogShow: false,
      form: {
        businessTypeId: '',
        businessTypeName: '',
        custId: '',
        custName: '',
        contactDept: '',
        contactDeptPerson: '',
        contactDeptPhone: '',
        shareUserId: '',
        userId: '',
        userName: ''
      },
      showServiceTypeTree: false,
      serviceTypeTreeList: [],
      fieldNames: {
        text: 'businessTypeName',
        value: 'businessTypeId'
      },
      list: this.listData,
      total: this.dataTotal,
      // dictDataOptions: this.dictOptions,
      dictDataOptions: {
        custLevelOptions: [],
        unitNatureOptions: []
      },
      washResultOptions: [],
      imageArr: [
        { image: require('@/assets/images/desktop/linkman2.png') }
      ]
    }
  },
  watch: {
    listData: function (newVal, oldVal) {
      this.list = newVal
    },
    isSupplier: function (newVal, oldVal) {

    }
  },
  props: ['listData', 'dictOptions', 'isAdd', 'dataTotal', 'isSupplier'],
  created() {
    // 清洗结果
    this.getDicts('crm_cust_wash_result').then((response) => {
      this.washResultOptions = response.data
    })
    if (this.isSupplier) {
      this.getDicts('sup_product').then(res => {
        this.dictDataOptions.custLevelOptions = res.data
      })
    } else {
      // 客户等级
      this.getDicts('crm_cust_level').then(res => {
        this.dictDataOptions.custLevelOptions = res.data
      })
    }
    // 单位性质
    this.getDicts('crm_unit_nature').then(res => {
      this.dictDataOptions.unitNatureOptions = res.data
    })
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    },
    timeFormat2(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    toDetails(item) {
      if (!this.isAdd) {
        this.$emit('todetail', item)
      }
    },
    handleShare(row) {
      this.form.custId = row.custId
      this.form.custName = row.custName
      this.form.userId = row.userId
      this.form.userName = row.userName
      // const userId = this.$store.state.user.user.userId
      // const this_ = this
      // getUser(userId).then(res => {
      this.dialogShow = true
      //   this_.form.deptName = res.data.dept.deptName
      //   this_.form.linkman = res.data.nickName
      //   this_.form.mobile = res.data.mobile
      // })
      // const that = this
      // if (row.userId == this.$store.state.user.user.userId) {
      //   Toast.success('无法申请已有客户')
      //   return
      // }
      // row.shareUserId = this.$store.state.user.user.userId
      // batchApplyShare(row).then((res) => {
      //   Toast.success(res.msg)
      //   this.$router.push({
      //     name: 'share',
      //     query: {
      //       code: 0
      //     }
      //   })
      // })
    },
    // 打开联级选择框
    async showPicker() {
      if (this.serviceTypeTreeList.length == 0) {
        // 获取业务类型
        await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
          if (response.code === 200) {
            this.serviceTypeTreeList = this.getData(response.rows)
          }
        })
      }
      this.showServiceTypeTree = true
    },
    onFinishServiceTypeTree(obj) {
      this.form.businessTypeId = obj.value
      this.form.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      this.showServiceTypeTree = false
    },
    async beforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.form.validate()
          if (this.form.userId == this.$store.state.user.user.userId) {
            Toast.success('无法申请已有客户')
            return
          }
          this.form.shareUserId = this.$store.state.user.user.userId
          batchApplyShare(this.form).then((res) => {
            Toast.success(res.msg)
            setTimeout(() => {
              this.$router.push({
                name: 'share',
                query: {
                  code: 0
                }
              })
            }, 500)
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
      }
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    handleList(row) {
      this.$router.push('list?custName=' + row.custName)
    },
    handleApply(row) {
      const ids = []
      if (row.custId) {
        ids.push(row.custId)
      }
      if (ids) {
        Dialog.confirm({
          title: '申领提示',
          message: '是否确认申领？'
        }).then(() => {
          addApply({ ids: ids }).then((res) => {
            Toast.success(res.msg)
          })
        })
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.dictDataOptions[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .y{
    display: flex;
    align-items: center;
  }
  /deep/.van-dialog{
    height: 60%;
  }
  .editClue /deep/.van-dialog__content {
    height: 72%;
  }
  .van-notice-bar{
      height: 60px;
      font-size:16px;
  }
</style>
